import { skipToken } from '@reduxjs/toolkit/query';

import { FeeService } from '../models';

import { useGetFeeServiceQuery } from '../services/fee-services.service';

interface Props {
  feeServiceId: string;
}

const useFeeService = ({ feeServiceId }: Props) => {

  const { data, isLoading, error } = useGetFeeServiceQuery(feeServiceId ? { feeServiceId } : skipToken);

  return {
    isLoading, error,
    feeService: data || {} as FeeService,
  };

};

export default useFeeService;
